module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-num"
  }, [_c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_vm._v("Chapter Three")])]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('h2', {
    staticClass: "chap-title"
  }, [_vm._v("A queer war")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("AC1 Fred Roberts:")])]), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "page47"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_vm._v("On Sunday, 3 September 1939, several 19 and 66 Squadron armament personnel, myself included, spent the day transporting .303 ammunition from railway wagons in Whittlesford Yard to the Duxford ammunition store. None of the aircraft were yet armed, however. Whilst we worked in the yard, evacuee trains passed by. When the Prime Minister broadcast to the nation that morning, the landlord of a nearby pub called us in to listen to Mr Chamberlain’s speech. He took us in the back room with a free pint as it was not yet twelve noon, meaning he was unable to serve us.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note85",
      "id": "footnote85",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was a historic moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chamberlain spoke to the nation at 1115 hrs:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This morning the British Ambassador in Berlin handed the German Government a final Note stating that, unless we heard from them by 11 o’clock that they were prepared at once to withdraw their troops from Poland, a state of war would exist between us. I have to tell you now that no such undertaking has been received, and that consequently this country is at war with Germany."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note86",
      "id": "footnote86",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("So it was that, in spite of every effort to avert such a catastrophe, Britain and France declared war on Nazi Germany. For the second time during the twentieth century, what Shakespeare had called the ‘blast of war’ resonated and had violent consequences once again, a bitter personal blow indeed to the British prime minister.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_vm._v("Fred continues:")])]), _c('a', {
    attrs: {
      "id": "page48"
    }
  }), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "page48"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_vm._v("After the Prime Minister’s speech, the sirens sounded and the Squadron was scrambled. We all thought ‘They won’t shoot much down with empty ammo boxes!’ From then on, the Armament Section was kept very busy as we had to re-sight the new Browning guns and reflector gunsights – when I arrived some of the Spitfires still had the old ring and bead sight. We also practised re-arming repeatedly until two armourers and assistants could change all eight ammo tanks, cock all guns and replace all panels in around three minutes.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note87",
      "id": "footnote87",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 3 September 1939 the 19 Squadron diary recorded that:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Due to the partial mobilization completed during the preceding few days, declaration of war against Germany at 1100 hrs found the Squadron almost on a war footing and ready for any eventuality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Squadron Leader Cozens AFC was in command with Pilot Officer F.N. Brinsden as Adjutant. Flight Lieutenant L.C. Withall commanding A Flight and Flight Lieutenant A.J. Banham commanding B Flight. Flying Officers W.G. Clouston, T.G. Pace, J.B. Coward, A.I. Robinson, G.C. Matheson; Pilot Officers G.L. Sinclair, G.E. Ball, A.J.A. Llewellyn, G.W. Petre, L. Marples, M.D. Lyne, L.A. Haines, J.H. Bowring. Flight Sergeant H. Steere. Sergeants J.A. Coleman, G.C. Unwin, J.H. Potter, P.S. Gunning, T. Boyd, A.E.A. Bruce (RAFVR), comprised the remainder of the flying personnel, the majority of whom were quite conversant with the characteristics of the Spitfire Is with which the Squadron had been fully equipped for almost a year."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note88",
      "id": "footnote88",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Flying Officer James Coward:")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p49-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_vm._v("An informal snapshot of 19 Squadron pilots in September 1939. Those identified are, back row, second left: Pilot Officer Gordon Sinclair; centre: Pilot Officer Withall; with pipe: Flying Officer Gordon (not Douglas Bader, as reported in my "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Duxford 1940")]), _vm._v(" book); fifth from right: Squadron Leader Cozens; fourth right: Flying Officer Matheson; third right: Pilot Officer Coward; second right: Pilot Officer Robinson; extreme right: Pilot Officer Clouston. Kneeling, second left, is Pilot Officer Brinsden.")])]), _c('a', {
    attrs: {
      "id": "page49"
    }
  })]), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p49-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Early spring 1940. At left: is Pilot Officer Peter Howard-Williams with Squadron Leader Cozens’s successor, Squadron Leader Geoffrey Stephenson (third right), and unidentified RAF personnel with two visiting French air force pilots.")])])]), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "page49"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_vm._v("From my log book I see that on 3, 4 and 5 of September 1939, we were scrambled at night, on one occasion as a Squadron, but of course no enemy aircraft were sighted. I believe that the ‘enemy’ turned out to be our own aircraft returning in the wrong places. Night flying in a Spitfire was always a little bit tricky, with a ")]), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_vm._v("bright exhaust flame on either side, a narrow undercarriage, and uneven grass strips of limited length, but after war started on a dark night one was on instruments as soon as one passed the last dim Glim Lamp on take-off, as the whole country was blacked out. One pilot … displayed a remarkable feat of airmanship by forced-landing a Spitfire at night in a field, which was too small for a subsequent take-off – his engine had cut-out on take-off, at about 500 feet. He dropped a flare and glided safely down with no damage to the aircraft. Most pilots would have been hard pressed to do it in daylight.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note89",
      "id": "footnote89",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once war started, we were called to Readiness as a Squadron and stayed at Readiness right through the night. We slept on our camp beds under the wings of the aircraft in our flying gear, ready to go. Each night we were sent off and the first night we intercepted some of our aircraft returning in the wrong places along the coast. Same thing on the second sortie when I nearly shot one down. It gets very exciting when you have a controller telling you one bandit three miles ahead, now two miles ahead, gets you all keyed-up for this great attack. I just saw this aircraft silhouette and luckily recognised it as a Blenheim. I could so easily have shot it down."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note90",
      "id": "footnote90",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The very great and real fear at this time was that Germany would deliver an immediate aerial ‘knock-out blow’ from across the North Sea. The air defences of East Anglia, however, were sparse. New aerodromes near Norwich, at Horsham St Faith and Coltishall, were incomplete. No. 12 Group’s Debden Sector spread east over Essex, guarding the northern approach to London, and Wittering protected Duxford’s northern flank. The area between Debden and Wittering sectors was Duxford’s responsibility. Immediately war was declared, therefore, Duxford’s squadrons sent flights of Spitfires daily to the advanced landing ground at Watton, a bomber station near Thetford. This was to afford those stations fighter protection in case the Luftwaffe unleashed an all-out offensive against RAF bombers based in East Anglia, which were clearly a threat to Germany. Consequently, the Wellington and Blenheim bombers concerned withdrew to stations farther west, but it was considered that more fighters than those supplied by Duxford’s squadrons were required, leading to 73 Squadron’s Digby-based Hurricanes reinforcing the Duxford Sector. No. 19 Squadron also assumed responsibility for night readiness, hence the intensive night-flying activity, although after a "), _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_vm._v("week or so Duxford’s Spitfire squadrons alternated their defensive duties.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note91",
      "id": "footnote91",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flying Officer James Coward:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("We were sent forward to Watton at dawn and kept at readiness there all day, returning to Duxford at dusk. The Station Commander at Watton would not allow us to lunch in the Mess (when we were released by sections) because he did not consider that we were suitably dressed, being in flying kit. I don’t know whose side he was on, but it certainly wasn’t ours!"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note92",
      "id": "footnote92",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pilot Officer Michael Lyne:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Our aircraft were Spitfire Mk I with fixed-pitch, two-bladed wooden airscrews. The airfield had an 800 yards grass runway. With the poor take-off and on landing, and low braking effect of a coarse pitch propeller, we needed every yard of it. I was astounded, however, at the boldness of Squadron Leader Cozens in conducting formation landings at night in this aircraft, especially as the lighting consisted of the First World War style of paraffin lamps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In spite of the war, most of September was given over to practice flying, formation, high altitude (25,000 feet) and night flying. The blacking out of all towns and villages made this harder than we expected."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note93",
      "id": "footnote93",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Over the next few days, pilots were posted in and out of 19 Squadron. On 4 September 1939 Sergeant Bernard James ‘Jimmy’ Jennings reported for flying duties, another who became a Squadron stalwart during our forthcoming Finest Hour. Like George Unwin and Harry Steere, Jennings likewise had an interesting route to a Spitfire cockpit, for which he could also thank Trenchard’s foresight. Jimmy joined the RAF as a lowly aircrafthand in 1933, his first posting being to the Parachute Flight at Hendon. After a photographer’s course at Farnborough, Jimmy became a photographer and air gunner on 33 Squadron, with which he went to the Middle East.")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I wanted to be a pilot, and preferably a fighter pilot, so I applied, was successful and returned to train in England on 6 December 1937. Afterwards, I was posted to Cranwell as a "), _c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_vm._v("Signals Squadron pilot. When war broke out they needed fighter pilots, of course, so my chance came then, and I joined 19 Squadron at Duxford. I see from my log book that I flew a Spitfire Mk I, K9801, for the first time, ‘Experience on type’, for forty-five minutes on 5 September 1939. Over the days ahead we flew many training flights, including formation practice and the text-book ‘Fighter Attacks 1 & 2’. In those days, it was assumed that any air attack from Germany would come from across the North Sea, and because fighters have only limited range it was equally assumed that their bombers would be unescorted. We flew in tight formation, in sections of three in a ‘vic’ formation, the idea being that this would bring twenty-four machine-guns to bear simultaneously, as opposed to the eight of a single Spitfire. Each section would attack in turn, breaking away, and the enemy were expected to fly ponderously on, taking no evasive action. As things turned out, this was all wrong, but nobody knew that at the time. On 11 September I crashed K9799, when a tyre burst. I crashed again on 22 September, when I hit the picket at Watton on landing, undercarriage smashed. We also practised flying and landing at night and at dusk. It was quite intense.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note94",
      "id": "footnote94",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 5 September 1939 Pilot Officer Peter Vincent Watson ‘reported for flying duties from RAF Manby’."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note95",
      "id": "footnote95",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("11")])]), _vm._v(" A nineteen-year-old from Yorkshire, Peter was the youngest of two children born to Vernon Vincent and Christine Watson in Knaresborough. As Michael Lyne said, ")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Flying Spitfires was every young man’s dream, and being new pilots of a similar age, Peter and I became good friends and flew together in the CO’s Red Section. The war was still an adventure, I suppose, back then. We were keen – but very young and naïve."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note96",
      "id": "footnote96",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In contrast to the days of ‘strawberries and cream and fruitcake for tea’ of not so long ago, this was also now a busy time for 19 Squadron’s ground crews; Fred Roberts:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("We armourers and assistants practised re-arming for hours every day, until two of each could change all of a Spitfire’s eight ammo "), _c('a', {
    attrs: {
      "id": "page53"
    }
  }, [_vm._v("tanks, cock all guns and replace the panels in around three minutes flat. The ‘Flight Mechanics Airframe’ were re-spraying the Spitfires with war camouflage and changing the Squadron’s identity letters from WZ to QV, whilst the ‘Flight Mechanics Engine’ were helping Rolls-Royce personnel change the two-bladed Watts propeller to the three-bladed de Havilland variable pitch propellers, plus other modifications. We removed the camera guns from the starboard wing stub and installed cine-gun cameras in the port wing stub. Some Spitfires were still fitted with ring and bead sights, which had to be replaced with reflector sights.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note97",
      "id": "footnote97",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The propeller modification was a significant improvement, but the Spitfire still remained inferior to its Messerschmitt adversary in this respect. The angle at which a propeller bites into the air is known as the ‘pitch’. Changing pitch has the same effect on an aircraft’s performance as changing gear in a car. The Spitfire’s original Watts propeller was carved from mahogany, so the pitch was fixed and could not be changed. This was no different to the propellers of earlier, inferior, biplanes but the new, much more powerful engines provided for greater control and finesse. The Me 109 had also begun life with a fixed-pitch propeller, but this was rapidly changed to the VDM ‘controllable pitch airscrew’, enabling the pilot to rotate the blades through the full 360-degrees range and select the optimum pitch for any situation. The new three-bladed British propeller, however, made not of wood but of duralumin and produced by de Havilland, was only a halfway house between the fixed-pitch and VDM ‘Constant Speed’ (CS) unit because it only gave the pilot two options: coarse and fine pitch. This is another example of how British aircraft designers were behind their German counterparts who had the advantage of having used the Spanish Civil War as a proving ground.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Amongst the comings and goings at Duxford on 10 September 1939, a name is recorded which would become inexorably connected with 19 Squadron: Flight Lieutenant Brian John Edward Lane."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note98",
      "id": "footnote98",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brian was the only son of Henry Fitzgerald William Lane, an articled clerk (trainee solicitor) of Stroud in Gloucestershire, and Bessie Elinor Lane, who came from Bradford. Brian came along quite late in his parents’ lives, who were then aged thirty-nine and forty respectively, when he was born in Knaresborough on 18 June 1917, joining elder sister Hilda Geraldine (born 1 September 1912)."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note99",
      "id": "footnote99",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("15")])]), _vm._v(" During Brian’s childhood, the family "), _c('a', {
    attrs: {
      "id": "page54"
    }
  }, [_vm._v("moved to Pinner in Middlesex, setting up home at 17 Barrow Point Avenue. Brian was fortunate enough to receive a private education at St Paul’s, an independent boys’ school associated with the famous cathedral and located at Barnes in Richmond-on-Thames; as he once wrote, ‘I was born with a silver spoon in my mouth, which, they say, is a sign of luck.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note100",
      "id": "footnote100",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("16")])]), _vm._v(" Not so lucky was the outcome of Brian’s first job, in 1935, as an eighteen-year-old supervising female workers in a light-bulb producing factory: ‘I was not really surprised when one day the powers that be informed me that the period of my employment coincided with a decline in their profits, and if I would kindly leave them, they could get along better without me.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note101",
      "id": "footnote101",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("17")])]), _vm._v(" Having gone home to his ‘lamenting parents’, Brian decided to apply for an SSC in the expanding RAF. Having submitted his application, frustrated by the lack of progress, Brian began personally calling at the Air Ministry’s Adastral House on London’s Kingsway – so often that the desk sergeant began greeting him like an old friend. His tenacity paid off: at last he was called to attend a Selection Board, and passed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So it was that, on 22 March 1936, the young Brian Lane reported for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ab initio")]), _vm._v(" flying training with Air Service Training, a Civilian Flying School, at Hamble, near Southampton. John Wray, himself later a distinguished wartime pilot, was on the same courses:")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p54.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Brian Lane pictured as a pilot officer in 1936 (Henry Fargus).")])]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In those days, officers and NCO pilots on limited service engagements spent three months at an Elementary Flying Training School (EFTS) where they completed fifty hours dual and solo flying, and engaged in associated ground school subjects. They then proceeded to the depot at Uxbridge for general introduction into the service, including the issue of, "), _c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_vm._v("or, in the case of officers, the purchase of uniform. This lasted about one month. Then on to a Service Flying Training School for one year or ten months’ conversion onto service type aircraft and instruction in its use as a military weapon. Ground associated subjects were also studied and the whole training experience was now in a service environment with we officers learning to be such and the NCOs learning to be NCOs. My course at 11 FTS was drawn from two EFTS, Hamble and Anstey. Brian and I both went from Hamble to Wittering together. At Hamble we had flown the Avro Cadet biplane, the smaller brother of the Tutor, and Avro’s answer to the de Havilland Tiger Moth.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note102",
      "id": "footnote102",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hamble was not uneventful for the fledgling pilots. Soon after going solo, ‘feeling like a young god’, Brian was practising ‘circuits and bumps’ and narrowly avoided a fatal head-on collision with a rapidly approaching aircraft. Miraculously no one was hurt but Brian’s undercarriage hit and destroyed the other pilot’s rudder; fortunately, the only consequence was both pilots being advised by their instructors to say their ‘prayers twice that night’."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note103",
      "id": "footnote103",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brian left Hamble on 13 May 1936 and, after a brief period of ‘square bashing’ at Uxbridge, converted to service types at 11 FTS, Wittering, between 3 June 1936 and 8 January 1937. John continues:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Brian was rather languid and slow in those days and was not what one imagined a fighter pilot to be. He was always known as ‘Dopey’ Lane. He had deep set eyes with black rings underneath, nothing, I am sure, to do with his lifestyle, just natural characteristics! During those now far off days of training, only the very good pilots on the FTS course went to fighter squadrons, which meant, of course, the minority. For example, I was posted to an Army Co-operation squadron because, so I was told by the Chief Ground Instructor, ‘In Army Co-operation squadrons they need gentlemen, because you may have to take port with the general!’ ‘Dopey’ Lane was, however, posted to a fighter squadron upon conclusion of our course at Wittering. I would like to make one point abundantly clear: ‘Dopey’ Lane proved no dope when it came to being leader of a fighter squadron."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note104",
      "id": "footnote104",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p56-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_vm._v("From the album of Group Captain John Wray, who trained at Hamble with Brian Lane, an Avro Cadet trainer of Air Service Training at Hamble.")])]), _c('a', {
    attrs: {
      "id": "page56"
    }
  })]), _c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p56-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A ‘Miles Magister Initial Trainer’ from the wartime-published morale-boosting book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Britain’s Wonderful Air Force")]), _vm._v(". On 11 November 1938, Brian Lane and a passenger crashed in an aircraft of this type whilst flying from Wittering to Northolt – and were lucky to survive.")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_vm._v("Having been trained on Hawker Fury fighters, Brian applied for a posting to a fighter squadron, and was ‘tremendously pleased’ when, on 8 January 1937, he was ordered to 66 Squadron at Duxford. ‘Clickety-Click’ was another fighter squadron with a long and proud history, then flying the Gloster Gauntlet biplane, which, Pilot Officer Lane soon decided, was ‘one of the most wonderful aircraft ever built’.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note105",
      "id": "footnote105",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("21")])]), _vm._v(" After several months with 66, Brian applied to join a new squadron, 213, forming at Northolt, close to his parents’ home in Pinner. There the young pilot found his flight commander to be an old friend from St Paul’s, Flight Lieutenant Jackie Sing. No. 213 "), _c('a', {
    attrs: {
      "id": "page57"
    }
  }, [_vm._v("Squadron, under the command of Squadron Leader Edwardes-Jones, was a happy squadron, and Brian enjoyed the flying, moving with the squadron to Church Fenton on 1 July 1937, thence to Wittering on 18 May 1938. On 11 November 1938, however, he was flying Miles Magister L8136 with Pilot Officer R.F. Weatherill from Wittering to Northolt to go on weekend leave, when, whilst")])]), _c('a', {
    attrs: {
      "id": "page57"
    }
  }), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "page57"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page57"
    }
  }, [_vm._v("straight and level at 3000 feet near Henlow when aircraft commenced left-hand diving turn from which it did not recover. Hit deck at 1250 hrs at 200 mph. Walked away from it – just! Returned to duty 3/1/39. Longest weekend on record!")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note106",
      "id": "footnote106",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("22")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("According to the 213 Squadron diary, the lucky pair ‘sustained minor injuries. Aircraft written-off’."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note107",
      "id": "footnote107",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Back at Wittering, Flying Officer Lane, as he now was, got straight into the cockpit, flying aerobatics in Gauntlet K5285. On 20 January 1939 Brian flew a Hawker Hurricane for the first time, as 213 re-equipped with the modern fighter. The ‘Type’, he decided, was ‘OK. Nice kite altogether. Bit heavy after the Gauntlet – not surprising.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note108",
      "id": "footnote108",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("24")])]), _vm._v(" Thereafter the squadron flew intensive formation, night-flying and other training flights on the Hurricane, on which type Brian was authorised to perform aerobatics by 15 March 1939."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note109",
      "id": "footnote109",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("25")])]), _vm._v(" On 10 July 1939 his CO recorded Flying Officer Lane’s ability as a fighter pilot as ‘Above the average’."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note110",
      "id": "footnote110",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("26")])]), _vm._v(" Two months later, Brian was promoted to flight lieutenant and left 213 Squadron upon posting to 19. On that day, 10 September 1939, Squadron Leader Edwardes-Jones recorded Brian’s ability as a fighter pilot with 580.25 flying hours as ‘Exceptional’, "), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note111",
      "id": "footnote111",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("27")])]), _vm._v(" a rarely given rating.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 11 September 1939 Brian flew a Spitfire Mk I, L1032, for the first time, on a twenty-minute familiarisation flight. The Spitfire, Brian wrote in his log book, was ‘Quite pleasant’, but noted that the ‘undercart’ was a ‘bit of a menace’, referring to the undercarriage which had a narrower wheel track than the Hurricanes he had previously flown."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note112",
      "id": "footnote112",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("28")])]), _vm._v(" That afternoon, Brian led Flying Officer ‘Ace’ Pace, a buff on Great War fighter aces, and Pilot Officer Gordon Sinclair to Watton, ‘Map flew overboard but with amazing luck found the place OK.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note113",
      "id": "footnote113",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leaving 19 Squadron were both flight commanders, Flight Lieutenants A.J. Banham, who was posted to 611 (West Lancashire) Squadron of the Auxiliary Air Force, and LC Withall, who went to 126 Squadron."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note114",
      "id": "footnote114",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("30")])]), _vm._v(" No. 611 had flown to Duxford on 13 August 1939 and was embodied at Duxford, "), _c('a', {
    attrs: {
      "id": "page58"
    }
  }, [_vm._v("its designated war station, on 26 August, taking over the accommodation previously used by the Cambridge UAS. The newly-arrived squadron’s Spitfires were dispersed around the south-west corner of the airfield and ordered to stay put when general mobilisation was decreed a few days later. Consequently, Duxford was home to three Spitfire squadrons.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note115",
      "id": "footnote115",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The newly-promoted Flight Lieutenant Brian Lane became commander of 19 Squadron’s A Flight, but the newcomer was not entirely well received, as Frank Brinsden recalled:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("He was received politely but coolly as ‘Sandy’ Lane when he arrived from Wittering … because the residents of 19 Squadron thought a number of them could have filled the bill without calling in an outsider who, despite the small number of officer pilots in Fighter Command at that time, was unknown to us. However, within a week or two Brian’s calm dignity and professional skill showed through and the soubriquet ‘Sandy’ was never used again within the Squadron: he became ‘Brian’. The somewhat derogatory tag of ‘Sandy’ was quite incongruous. His dignity was not a pose and he enjoyed Squadron sorties to the local as much as we all did – and all were equal to him."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note116",
      "id": "footnote116",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("32")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p58.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Flight Lieutenant Brian Lane, commanding ‘A’ Flight, in his personal Spitfire Mk I in early 1940. Note that 19 Squadron’s code letters are now ‘QV’, and the ‘nose art’ adorning the cockpit door, ‘Blitzen’. Taken at Duxford, the 19 Squadron hangar can be seen with a snow-covered roof.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p59.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A snapshot of Brian Lane’s Spitfire in early 1940, by which time the fixed-pitch wooden airscrew had been replaced by the improved, three-bladed, De Havilland two-pitch propeller.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page59"
    }
  }, [_vm._v("This reaction to the unknown new flight commander is evidence of just how tightly-knit a pre-war fighter squadron was. Moreover, Frank’s comment that to Brian Lane ‘all were equal’ is significant because this was a time when society was distinctly hierarchical, with clear social classes and divisions. Brian Lane, a lawyer’s son who enjoyed a private education, was born to the upper middle class, so could perhaps have been snobbish, but that was not his style at all.")])]), _c('a', {
    attrs: {
      "id": "page59"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("AC1 Fred Roberts:")])]), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "page59"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page59"
    }
  }, [_vm._v("Some of the officers were a bit ‘toffee-nosed’, and of course never socialised with Other Ranks. Brian Lane was different. In those days, we Other Ranks were invariably called by our surnames, but Brian Lane knew everyone on the Squadron by their first names, regardless of rank or trade, which, especially at that time of the war, was unheard of in my experience. We all felt valued and equal to him. Of course, to us he was ‘Sir’ but in conversation between ourselves, he was always ‘Brian’. Everybody loved him, he treated us all with respect and had this calm kind of aura. Unique.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note117",
      "id": "footnote117",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("33")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page60"
    }
  }, [_vm._v("Throughout the autumn of 1939 No. 19 Squadron’s training flights went on. And on. And at night. On the night of 28 September Pilot Officer Leonard Archibald Haines crashed a Spitfire, K9841:")])]), _c('a', {
    attrs: {
      "id": "page60"
    }
  }), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "page60"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("During my last turn onto the flare path I observed my speed to be 85 mph and accordingly opened up the engine and applied opposite aileron and rudder in an endeavour to correct my altitude.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page60"
    }
  }, [_vm._v("The engine picked up at once, but it was too late for me to regain control, and the aircraft stalled from a height of ten feet, striking the ground heavily, causing the undercarriage to collapse.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note118",
      "id": "footnote118",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("34")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 2 October 1939 Duxford’s Station Commander, Group Captain H.L. ‘Pingo’ Lester, reported on the accident to the 12 Group AOC, Air Vice-Marshal Leigh-Mallory, attributing the cause to be ‘inexperience of pilot on this modern highly loaded type of aircraft … there was no negligence’."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note119",
      "id": "footnote119",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("35")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p60.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Not a modern digitally coloured photograph but a genuine wartime colour snapshot from the album of Air Vice-Marshal Michael Lyne – who took the picture when a pilot officer on 19 Squadron and from his own Spitfire. The leading Spitfire is flown by Flight Lieutenant Lane, the other by Michael’s friend Pilot Officer Peter ‘Watty’ Watson.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page61"
    }
  }, [_vm._v("The AOC agreed, confirming on 11 October 1939 that no court of inquiry would be held.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note120",
      "id": "footnote120",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("36")])]), _vm._v(" The young pilot responsible was doubtless relieved, as was his father, Archibald Haines, to learn that his son was uninjured.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 1 October 1939 the ‘residents’ of 19 Squadron were doubtless delighted that instead of another unknown outsider being posted in, one of their own, Wilf Clouston, was promoted to flight lieutenant and succeeded Flight Lieutenant Carr Withall as commander of B Flight. Clouston was a twenty-four-year old New Zealander, hailing from Auckland, who had learned to fly privately at Rongotai before successfully achieving an SSC and joining 19 Squadron in June 1937. He was, therefore, well-known to his fellow pilots and, as one of the originals, was an experienced Spitfire pilot. Six days later, however, Clouston was leading a formation from Watton back to Duxford when Pilot Officer Eric Ball collided with his flight commander’s Spitfire, so damaging the aircraft’s tail unit that Clouston had no choice but to force land on Newmarket racecourse. Fortunately, both pilots involved were unhurt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In spite of numerous scares and false alarms, however, the dreaded and expected ‘knock-out’ blow fortunately failed to materialise. Indeed, it was as Brian later wrote, ")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was a queer war. Everybody said so. The experts said it was going to be a war of attrition. Maybe that was their word for it but it was still a queer war. The Luftwaffe’s expected blows on this island did not fall. Göring contended himself instead with raids by single aircraft against the convoys round the coasts. So, for month after month we patrolled the shipping, no doubt frightening away many Huns but never so much catching sight of one."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note121",
      "id": "footnote121",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("37")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To Brian, a ‘queer war’ it may well have been; to others the ‘Phoney War’ or ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sitzkrieg")]), _vm._v("’ struck a chord in the popular vernacular.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fact was that the German air force was not equipped to administer a knock-out hammer blow. Indeed, like Britain, the German emphasis in the air was on defence at this time."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note122",
      "id": "footnote122",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("38")])]), _vm._v(" Hitler had made clear his intentions in Führer Directive No. 1 on 31 August 1939:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Luftwaffe is, first of all, to prevent action by the French and English air forces against the German army and German territory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page62"
    }
  }, [_vm._v("In operations against England the task of the Luftwaffe is to take measures to dislocate English imports, the armaments industry, and the transport of troops to France. Any favourable opportunity of an effective attack on concentrated units of the English Navy, particularly on battleships or aircraft carriers, will be exploited. The decision regarding attacks on London is reserved to me.")])]), _c('a', {
    attrs: {
      "id": "page62"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page62"
    }
  }, [_vm._v("Attacks on the English homeland are to be prepared, bearing in mind that inconclusive results with insufficient forces are to be avoided in all circumstances.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note123",
      "id": "footnote123",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("39")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Britain was not, of course, geographically situated to provide direct military assistance to its Polish ally, although Lord Gort’s British Expeditionary Force (BEF) was immediately sent to France in anticipation of Hitler’s attack on the west. The Poles were overwhelmed by Hitler’s new weapons and Blitzkrieg tactics, made possible through aerial supremacy, and surrendered on 27 September 1939. After this victorious first campaign, the German air force units which had taken part were withdrawn to bases in Germany for a winter of rest, re-fitting and expansion ready for the forthcoming spring campaign against the west. Indeed, operational activity was decidedly minimal, with the few German fighters facing the Maginot Line forbidden to seek combat, whilst aerial activity against Britain comprised armed reconnaissance of ports and naval bases in particular, with occasional bombing attacks, largely by lone raiders."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note124",
      "id": "footnote124",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Royal Navy was much feared, and inevitably the anchorage at Scapa Flow in the Orkneys was a primary focus for the Luftwaffe. Scapa was also where, after the First World War, the German High Seas Fleet was interned, until the crews scuttled their ships in 1919. This hated British naval base, therefore, had a special significance for the Germans, who sought to avenge this ignominy. During the early hours of 14 October 1939, Kapitänleutnant Gunther Prien negotiated Scapa’s defences in his submarine, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("U-47")]), _vm._v(", sinking HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Royal Oak")]), _vm._v(": 834 of the ship’s crew of 1,234 men were lost. Furthermore, on 16 October 1939, nine Ju 88 bombers of I/KG30 delivered the first bombs dropped on British territory when they attacked coastal objectives in the Firth of Forth. Clearly the enemy was getting bolder. In response, on the following day, 19 Squadron was ‘ordered to be ready to move to Turnhouse to be in the vicinity of enemy aircraft raids’."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note125",
      "id": "footnote125",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("41")])]), _vm._v(" Turnhouse, near Edinburgh, was the base of 603 Squadron, the local AAF unit which, it was proposed, 19 Squadron, the RAF’s most "), _c('a', {
    attrs: {
      "id": "page63"
    }
  }, [_vm._v("experienced Spitfire unit, would bolster. In the event, the move was cancelled owing to a storm lasting two days, preventing flying. Instead, on 20 October, Flight Lieutenant Clouston led a 19 Squadron detachment of ‘10 officer pilots’ to ‘Catterick instead of Turnhouse … together with 7 sergeant pilots and 57 airmen’, ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note126",
      "id": "footnote126",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("42")])]), _vm._v(" the intention being for the Spitfires to provide protection to shipping.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Almost immediately, on 21 October 1939, the Yorkshire detachment experienced excitement: at 1009 hours, Blue Section, comprising Flight Clouston, Pilot Officer Sinclair and Flight Sergeant Steere, was scrambled, vectored to Scarborough at ‘angels 10’ (10,000 feet), and at 1015 hours ordered to investigate ‘Raid X40’ on the plotting table. The section also patrolled over Whitby and Flamborough Head, but nothing was seen."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note127",
      "id": "footnote127",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("43")])]), _vm._v(" At 1425 hours, Blue Section, in which Sinclair had been replaced by Pilot Officer Petre, was scrambled again, this time to intercept ‘Raid X3’, approaching Flamborough Head. At 1457 hours, Clouston was ordered ten miles out to sea from that location, three minutes later sighting a German bomber at 1,000 feet, threatening a convoy. Suddenly, all hell broke loose as every gun on the ships below opened up, preventing the Spitfires from attacking. Unfortunately, when this barrage ceased, the raider had disappeared."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note128",
      "id": "footnote128",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("44")])]), _vm._v(" Unsurprisingly, ‘cheated of their prey’, the pilots’ remarks ‘about the Senior Service were neither respectful or complimentary!’"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note129",
      "id": "footnote129",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("45")])]), _vm._v(" With the onset of winter fast approaching, it would be some time before another chance to damage the Luftwaffe presented itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pilot Officer Michael Lyne:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("By October 1939, we were operational, going forward to spend the days at the bomber airfield at Watton, living in tents and forbidden the Officers’ Mess because the Station Commander didn’t like the way we fighter pilots looked in our flying boots and heavy sweaters, ready for unheated and unpressurised flight at high altitude; in some ways it was still very much a peacetime air force.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 20 October, we made a sudden move to Catterick, with groundcrews and equipment being carried in four-engine Ensign transports. This was in response to the German attack on the Firth of Forth, each Squadron moving North one stage. We did a few convoy protection patrols near Flamborough Head and returned to Duxford a week later."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note130",
      "id": "footnote130",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("46")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "page64"
    }
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p64-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Sergeant Jimmy Jennings running up to test magnetos at Catterick (Julie Jennings).")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p64-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("From left: Pilot Officer Frank Brinsden, Pilot Officer Geoffrey Matheson and Flight Lieutenant Brian Lane – the latter two pilots shared a room at Duxford.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("AC1 Fred Roberts:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 19 October 1939 we armourers and assistants were given two hours to pack our kit … told to report to the Guard Room for transport to Cambridge Railway Station – we were going to Catterick … the rest of A Flight personnel flying the following day. There was one exciting incident at Catterick when one of our Spitfires came roaring back on his own from a patrol, leaking glycol like a vapour trail. Everyone thought he had been hit by enemy fire. We returned to Duxford on 27 October, the whole of our ground personnel flying back in two stripped out Imperial Airways Ensigns. We landed at Duxford after dark and I think all of the Station’s personnel were on the tarmac to greet us. The journey back, although a bit bumpy, was a lot better than the train journey North!"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note131",
      "id": "footnote131",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("47")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page65"
    }
  }, [_vm._v("The day after 19 Squadron’s Catterick detachment returned to Duxford, Spitfires of 602 (City of Glasgow) Squadron, another AAF unit, shot down a KG26 He 111 engaged on an armed reconnaissance sortie over the Firth of Forth; the enemy aircraft force-landed on a hillside East of Humbie and was the first of many German aircraft to crash on British soil during the Second World War.")])]), _c('a', {
    attrs: {
      "id": "page65"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page65"
    }
  }, [_vm._v("On 1 November 1939 ‘A new type of Spitfire fitted with a “Rotol” Constant Speed airscrew was collected by Squadron Leader Cozens who began to carry out intensive flying and reliability trials with this aircraft.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note132",
      "id": "footnote132",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This new propeller, made of magnesium, was potentially a great step forward, but, as previously explained, the Me 109 already enjoyed the benefits of a constant-speed VDM propeller, whilst British aircraft at this time only had two-pitch airscrews. Thus, in what was a programme to increase and improve performance, Squadron Leader Cozens had the opportunity to evaluate a Spitfire with a CS airscrew, which, if successful, could make a real difference.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pilot Officer Michael Lyne:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In November we started patrolling from the new Norwich airfield of Horsham St Faith. The Mess was not ready so we all lived in a house called ‘Redroofs’. There was no night-flying so our social life was active. When we were at Horsham on a Sunday we gave an unofficial flying display at low level for the local population. This system of forward-basing and coastal patrols continued throughout December and into January 1940.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The flying conditions over this period were often very frightening, there being no proper homing or landing aids and a very poor out of date cockpit radio. After a spell above cloud you let down gently and hoped that you were over the sea or fens. Sometimes the ground did not show up until you got to "), _c('a', {
    attrs: {
      "id": "page66"
    }
  }, [_vm._v("300 feet, when the problem became one of trying to recognise somewhere in the rain and mist. A lovelorn section leader, Flying Officer Matheson, nearly did for me in these conditions when he took us back from Horsham in terrible weather so as to keep a date in Cambridge!")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note133",
      "id": "footnote133",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("49")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At the time, Alfred ‘Woody’ Woodhall was ‘Squadron Leader Flying Ops’ at Duxford, and second only to the Station Commander, Wing Commander Lester:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The squadrons, in those early days, had very little rest. From before dawn they were either flying on patrols over the coastwise convoys passing up and down the East coast, carrying out flying training or at ‘Readiness’ at their dispersals. Night-flying training was carried out as soon as dusk fell. For forward bases we used Coltishall and "), _c('a', {
    attrs: {
      "id": "page67"
    }
  }, [_vm._v("Horsham St Faith on the Norfolk coast … This entailed taking-off from Duxford before dawn and returning after dark in order to maintain the convoy patrol throughout daylight hours. The boredom, long hours with insufficient sleep, no action and no leave, soon began to tell on the pilots. This fatigue showed itself rather alarmingly when one of the flight commanders, leading his formation in to land, actually fell asleep when on the final approach.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note134",
      "id": "footnote134",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("50")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("So strongly did Woodhall feel about this that he personally flew up to 12 Group HQ at Hucknall to argue the case for a better system with the AOC. Leigh-Mallory agreed and")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("the state of readiness was relaxed considerably so that pilots were given 48 hours leave at reasonable intervals. The sad part was that when we landed back at Duxford, Jimmy Copley, the Station Adjutant, who had flown up with me as a passenger, and I were greeted by ‘Pingo’ Lester with the dreadful news that Jimmy’s son had been killed in a flying accident at Wittering that afternoon – it was thought that fatigue was the cause."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note135",
      "id": "footnote135",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("51")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("AC1 Fred Roberts:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In November, a detachment of about twenty Flight Mechanics Airframe, Armourers, a cook and a driver were sent to Horsham St Faith as a refuelling and re-arming unit. The personnel were to be changed every two weeks … We were billeted in a private house named ‘Red Roofs’, that had been commandeered and the residents moved elsewhere when airfield construction commenced. This house was situated on Fifers Lane, on the airfield’s cityside boundary. We had a mobile field kitchen at the back of the house and were totally self-contained, rations being sent weekly from Duxford by road, mail being sent daily in the flare tube of the flight leader’s Spitfire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whilst on the ground at St Faith, the aircraft were dispersed close to the boundary fence on Fifers Lane. At weekends we had hundreds of Norwich people lined up along the fence waiting for things to happen. Sometimes the pilots gave them a miniature air display before returning to Duxford around 1530 – 1600 hrs. The front room of the house was the pilots’ rest room during the day. Also, on the ground floor there was a radio transmitting and receiving station, and the telephone was manned 24 hours per day … The novelty of the detachment and being free of restrictions soon wore off with twenty or so airmen sharing the three bedrooms and sleeping four inches off the floor on bed-boards. After the Spits returned to Duxford our time was our own. We had no booking out or other restrictions but stayed in the house most nights. We spent an occasional Wednesday evening and every Saturday evening in the Norwich Lido Ballroom. It was mostly a drink and a chat in the warmth of the dance hall as only a few of the lads could dance."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note136",
      "id": "footnote136",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("52")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In conclusion, of November 1940, the 19 Squadron diarist wrote that")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The month has been very quiet with no offensive or defensive patrols against enemy aircraft being ordered. The monotony of life in the Sector was alleviated by night flying practices, squadron formation air drill, affiliation exercises carried out against various bomber units and day flights made to an advance aerodrome at Horsham St Faith. In addition, low flying attacks were practised in order to rest the ground defences of Marshall’s Aerodrome Cambridge."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note137",
      "id": "footnote137",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("53")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page68"
    }
  }, [_vm._v("The last month of 1939 was quieter still, poor weather being the cause, and because of this there was no night flying at all. On 16 December B Flight’s boredom was relieved by air-to-ground firing practice at the Sutton Bridge gunnery range, and on one occasion three B Flight Spitfires were scrambled to intercept what proved to be a friendly aircraft, but that was all. On 20 December, however, ‘Squadron Leader G.D. Stephenson reported from Air Ministry preparatory to taking over command from Squadron Leader H.I. Cozens AFC.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note138",
      "id": "footnote138",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Geoffrey Dalton Stephenson was a former Cranwellian, part of the RAF officer elite, the importance of which in terms of service connections cannot be over emphasised. Indeed, ‘AHF’, an otherwise anonymous inter-war flight cadet, wrote that ‘the associations of Cranwell are enjoyed only by a privileged few, who are closely bound together by their careers.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note139",
      "id": "footnote139",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("55")])]), _vm._v(" On")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stephenson’s course was a charismatic and strongwilled flight cadet, whose name would become a legend first within the RAF, then globally: Douglas Bader. The pair became firm friends and, on 25 August 1930, reported together to fly Gloster Gamecock fighters at Kenley with 23 Squadron. Both Pilot Officers Bader and Stephenson had an exceptional gift for aerobatics, which was rapidly identified by their flight commander, Flight Lieutenant Harry ‘Pricky’ Day. At the 1931 Hendon Air Pageant, Day and Bader represented 23 Squadron in and won the RAF pairs competition; Stephenson was reserve pilot. Bader, however, had an ill-disciplined penchant for unauthorised low flying, ignoring several warnings against this from Day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 14 December 1931 Bader and Stephenson joined Pilot Officer McKenna on a threesome to the civilian flying club at Woodley, near Reading, to lunch with the latter’s brother. As the three Bristol Bulldog fighters left, they performed a ‘Prince of Wales feathers’ manoeuvre, involving the central machine climbing vertically whilst those either side did so briefly before peeling away. Bader’s was the left-hand aircraft. After successfully completing the impressive display, Bader broke formation and returned to beat up the field at zero feet. As he swept over the field at 125 mph, his fixed undercarriage just ten feet above the grass, Bader began a slow right-hand roll. The problem with this was that a slow roll subjects an aircraft to greater forces of gravity, meaning that to counter this the pilot needs to increase thrust – but at this speed there was no reserve in a Bulldog. An irretrievable slide began. With no safety margin the left wing-tip touched the ground. In a fraction of a second the aircraft was breaking up, the airscrew and engine tearing lose "), _c('a', {
    attrs: {
      "id": "page69"
    }
  }, [_vm._v("and bounding across the field. Shocked onlookers rushed to the scene, finding Pilot Officer Bader still alive in the debris of his wrecked aircraft, but gravely injured. Incredibly, Bader survived the crash but both legs were amputated, one above, the other below, the knee. Of the life changing accident, in his log book, Bader wrote simply ‘Crashed slow-rolling near ground – bad show’.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note140",
      "id": "footnote140",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mastering mobility on artificial limbs, Bader returned to duty but because King’s Regulations failed to provide for disabled pilots, was not allowed to fly. Unable to tolerate a non-flying role, Bader left the service he loved so much in 1933. As things turned out for Bader, and as we will see, his old friend’s appointment as CO of 19 Squadron would prove significant, confirming the anonymous flight cadet’s appraisal of Cranwell’s benefits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On New Year’s Day 1940 Squadron Leader Cozens AFC was promoted to wing commander and posted to the Air Ministry. Cozens left 19 Squadron safe in the knowledge that he had successfully overseen introduction of the RAF’s most advanced fighter aircraft into operational service. On the same day Squadron Leader Stephenson formally assumed command of the RAF’s premier Spitfire squadron.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For 19 Squadron, January 1940 continued with the monotonous round of largely uneventful convoy protection sorties over the North Sea. At 1230 hours on 17 January, Yellow Section, comprising Flying Officer Andrew Robinson, Flight Sergeant George Unwin and Sergeant J.A. Coleman, relieved Red Section on a standing patrol. In good visibility at 6,000 feet, Robinson saw a lone raider at 33,000 feet, and gave chase. After flying 130 miles out over the inhospitable North Sea, however, the Spitfire pilot was unable to overtake the enemy bomber and so returned to Martlesham Heath, from where A Flight was operating, short of fuel."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note141",
      "id": "footnote141",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("57")])]), _vm._v(" It proved to be the only sortie of any note throughout the first month of 1940.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The beginning of February 1940 found Duxford under snow, with no flying at all until the 10th, when convoy patrols resumed. Postings of pilots in and out of the squadron continued; on 7 February: ‘Flying Officer D.R.S. Bader posted to Squadron from CFS Upavon.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note142",
      "id": "footnote142",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("58")])]), _vm._v(" Bader, though, was no ordinary flying officer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unable to fly, Pilot Officer Bader was formally retired from the RAF on 30 April 1933 with an annual pension of £200. He then went to work for the Asiatic Petroleum Company but office-based tedium was incomparable to the excitement of being an RAF aerobatic pilot. On 5 October 1933 Douglas Bader married Thelma Edwards at Hampstead Register Office, "), _c('a', {
    attrs: {
      "id": "page70"
    }
  }, [_vm._v("and also discovered that golf was a game at which he could compete on equal terms with the able-bodied. He watched with concerned interest developments in Germany. When Munich came in 1938, Douglas knew that war was coming and so wrote and offered his services to the Air Ministry. The response was a polite refusal on the grounds of King’s Regulations, tempered with an offer of an administrative role, which Douglas equally politely rejected out of hand. Flying was an integral part of Douglas Bader’s very being. Combat flying was an exciting experience without parallel, so far as he was concerned, and if there was going to be a war, he was determined to be in it, legs or not. Douglas continually campaigned to be re-admitted to flying duties, petitioning the Air Ministry and calling on the support of his many service friends, some of whom had risen to senior and influential rank. In short, Douglas resolved to harness the ‘Old Boy Network’ and ‘associations of Cranwell enjoyed by but a privileged few’ to his full advantage.")])]), _c('a', {
    attrs: {
      "id": "page70"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page70"
    }
  }, [_vm._v("When Hitler invaded Czechoslovakia on 16 March 1939 there was no longer any doubt that war was imminent. At that time, Flight Lieutenant Geoffrey Stephenson, Bader’s old Cranwell chum, was serving at the Air Ministry and able to solicit support for his friend’s cause from the personal staff officer to the new Air Member for Personnel, Air Marshal Sir Charles Portal, the man ultimately responsible for all personnel decisions. Portal decided that, if war came, Bader could fly. So, whilst the majority of the population hoped against hope that war with Germany would be avoided, Bader prayed that it would come – and soon. When war was declared, he immediately wrote again to Portal and was invited to Adastral House for a selection interview. The interviewing officer, by happy ‘coincidence’, was none other than Air Vice-Marshal Halahan, Bader’s old Cranwell commandant who sent his old pupil to the Central Flying School (CFS) for a flying test. On 22 October 1939 Bader attended the CFS at Upavon; allocated to A Flight, he found another old Cranwell chum, Squadron Leader Rupert ‘Lucky’ Leigh, in command. Bader knew that ‘under the\n“Old Chum’s Act”’ the flying test was ‘in the bag unless he made some unthinkable blunder’.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note143",
      "id": "footnote143",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("59")])]), _vm._v(" The flying test was undertaken in a Harvard, an American-built monoplane type Bader had not previously flown. The difference, however, between British and American aircraft was that the former’s brakes were operated by a lever on the control column but by foot pedals on American types. Fortunately for Bader, Leigh operated the foot-brakes for him and the ecstatic legless pilot passed the test. Restored to the active list on 27 November 1939, Flying Officer Bader reported to Upavon "), _c('a', {
    attrs: {
      "id": "page71"
    }
  }, [_vm._v("for a refresher course and conversion to modern aircraft types. His first flight was as a passenger in an Avro Tutor, his second a solo sortie which included an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("inverted")]), _vm._v(" circuit of the aerodrome.")])]), _c('a', {
    attrs: {
      "id": "page71"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Squadron Leader Woody’ Woodhall:")])]), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "page71"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page71"
    }
  }, [_vm._v("One day, Douglas Bader flew over from the CFS in a Hurricane. I was delighted and amazed to see him, as I had not done so since his crash. He was in terrific form, and, as it happened, the Air Officer Commanding (AOC) also came to visit us that day. I introduced Douglas to the AOC, Air Vice-Marshal Leigh-Mallory, and over lunch Douglas used all his considerable charm to persuade ‘LM’ to take him into one of his operational fighter squadrons. After lunch, with the AOC watching, Douglas put on a most finished display of aerobatics, and this finally decided LM. Douglas impressed us all with his terrific personality and amazing keenness and drive. I have never known his equal. Flying was his supreme passion and his enthusiasm infected us all.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note144",
      "id": "footnote144",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("60")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There can be little doubt that Bader’s arrival over Duxford in a Hurricane during the AOC’s visit was not coincidental, given that Squadron Leader Geoffrey Stephenson was commanding 19 Squadron at the time. Little wonder, then, that it was to this station and squadron that Flying Officer Bader was subsequently posted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("AC1 Fred Roberts:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I was walking across the hangar from the armoury to the groundcrew rest room on 8 February 1940 when I saw this new pilot, a flying officer, in front of me walking with a queer lurching gait. I asked questions and was told that this was Flying Officer Douglas Bader, who had lost both legs in a flying accident during 1931, and now walked on two metal legs. We were all wondering what position he would hold on the Squadron, not realising that he was now amongst our complement of pilots. A little later that day he gave a magnificent display of aerobatics in the Squadron’s Miles Magister. We also learned that he was a great friend of the CO, Squadron Leader Stephenson, with whom he had flown in the RAF aerobatic team."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note145",
      "id": "footnote145",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("61")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page72"
    }
  }, [_vm._v("AC1 Ernie French was another member of 19 Squadron’s ground crew who recalled Flying Officer Bader’s arrival:")])]), _c('a', {
    attrs: {
      "id": "page72"
    }
  }), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "page72"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page72"
    }
  }, [_vm._v("My first sight of him was arriving in his MG. He often took me and other airmen flying in the two-seater Master, making me sit in the front cockpit and joking ‘French, make sure you start her up before you get in!’ These were cross-country flights and he would point out his digs in March and other landmarks.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note146",
      "id": "footnote146",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("62")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Given the substantial technical differences between the biplanes he had flown previously and the new monoplane fighters, Flying Officer Bader’s Spitfire transition was not an entirely seamless process. His first Spitfire flight occurred on 12 February 1940. Beforehand, Bader sat in the cockpit of K9853, whilst ‘a young pilot officer, with little experience, showed me the knobs. He omitted to tell me one important thing about the undercarriage operation which embarrassed me in due course, fortunately without damage.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note147",
      "id": "footnote147",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An unimpressed Pilot Officer Frank Brinsden, however, tells a somewhat different tale:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I feel free to elaborate on this comment as Douglas raised the matter and I was there. Any ‘young pilot officer with little experience’ on 19 Squadron assigned to brief Douglas Bader would actually have been flying Spitfires since October 1938. By early February 1940, when Bader came on the scene, that pilot officer would have been qualified to fly operationally by both day and night. Is such a pilot officer therefore likely to have omitted from the briefing the rather important matter of raising the undercarriage? In any case the crew room had an ample supply of Pilot’s Handling Notes and anyone who embarked upon his first solo in such a (for its time) radical aircraft without fully understanding its controls was a complete bloody fool! It must be remembered that the biplanes with which Bader had previously been familiar had a fixed undercarriage. Although he had flown a handful of hours in a Hurricane, retractable undercarts remained relatively new to him."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note148",
      "id": "footnote148",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("64")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pilot Officer Michael Lyne:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("By March 1940 the weather was better but we now had Flying Officer Douglas Bader to contend with. He was very brave and "), _c('a', {
    attrs: {
      "id": "page73"
    }
  }, [_vm._v("determined but having a hard time getting to grips with the Spitfire, a far more advanced machine than he had flown previously. He particularly experienced problems in cloud. More than once my friend Watson and I were lent to Bader as a formation by the CO, but emerged from cloud faithfully following our leader only to find ourselves in a steep diving turn!")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note149",
      "id": "footnote149",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("65")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bader, the RAF legend, was not only having ‘a hard time’ with the Spitfire but also fitting into 19 Squadron as a comparatively junior officer, his rank not commensurate with either his age or contemporaries. Douglas was nearly thirty, a flying officer, whilst his Cranwell chums were largely all squadron leaders. So here was Flying Officer Douglas Bader outranked by much younger men, mostly SSC officers, and serving in a squadron commanded by his best friend and an exact contemporary. Bader’s antipathy is reflected in Paul Brickhill’s best-selling 1952 account of his life, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reach for the Sky")]), _vm._v(", referring to a flight with Brian, his flight commander, described as ‘an unblooded veteran of twenty-five’."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note150",
      "id": "footnote150",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("66")])]), _vm._v(" Brian was actually only twenty-three but had been a fighter pilot since 1936, had many flying hours on Hurricanes and Spitfires, and enjoyed an ‘Exceptional’ rating of his ability as a fighter pilot. Whilst on finals during this particular sortie, Bader’s Spitfire hit and removed the roof of Duxford’s cricket pavilion., removing his tail wheel in the process. According to Brickhill, the section leader, whom he does not identify by name but was Flight Lieutenant Lane, ‘came across laughing and said “I’m awfully sorry, ole boy. Most extraordinary thing – d’ya know not long ago I landed a chap in a tree just the same way”.’ He never forgot the blunt details which Bader told him about his character in the next five minutes."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note151",
      "id": "footnote151",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("67")])]), _vm._v(" This, like the story alleging that Brinsden failed to explain the Spitfire’s undercarriage controls, is completely untrue. Brian Lane was a quiet intellectual, a highly experienced and competent fighter pilot and leader, not a reckless flippant. This was actually only Bader’s second flight in a Spitfire. On the first he had ‘embarrassed’ himself by forgetting to lower the undercarriage. This latest accident was due entirely to his own inexperience on type and failing to cope with reduced visibility during landing caused by the Spitfire’s long nose. Later, during a dummy interception of Wellington bombers, Bader hit a tree whilst low flying. Characteristically he blamed his leader, but Stephenson’s response was ‘Well, you’re the silly clot. It’s up to you to see where you are going. He can’t fly the aeroplane for you,’"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note152",
      "id": "footnote152",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("68")])]), _vm._v(" suggesting that even his old friend was getting fed up with Bader’s lack of humility and inability to cope with actually being 19 Squadron’s most junior pilot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page74"
    }
  }, [_vm._v("As previously explained, German air attacks were expected to approach across the North Sea and comprise unescorted bombers. Consequently, the RAF tacticians devised ‘Fighting Area Attacks’ consisting of six set-piece attacks involving the whole squadron in sections of three. Indeed, owing to the high speeds now achieved by modern monoplanes, many believed that fighter versus fighter combat would no longer be an option owing to the higher stresses and strains on both aircraft and pilot. Douglas Bader disagreed, and poured scorn on the RAF manual, arguing that once battle was joined, each pilot should attack independently as he saw fit, not be bound to an inflexible rehearsed attack that in reality would be impossible owing to evasive action and return fire. In this, he was entirely correct. Bader held court, impressing his views on fighter tactics to all who would listen, and remonstrated with Stephenson regarding the formation attacks 19 Squadron trained on. Stephenson’s response was that he had no brief to deviate from the tactics stipulated by the Air Ministry, which relied upon teamwork and not independent action. This disagreement with Stephenson exasperated Bader.")])]), _c('a', {
    attrs: {
      "id": "page74"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("By this time, the Spitfire’s original fixed pitch airscrew had been replaced by the two-pitch de Havilland propeller, another modification with which Flying Officer Bader was unfamiliar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pilot Officer Michael Lyne:")])]), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "page74"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page74"
    }
  }, [_vm._v("On 31 March 1940 Douglas was leading our section of three Spitfires on a convoy patrol. We went off downwind on the shortest run at Horsham. Douglas, however, forgot to put the airscrew into fine pitch for take-off and cartwheeled across the main road and into a ploughed field. Watson and I stuck with him until the last minute but then pulled up and away on emergency power. I remember only just clearing the hedge and seeing clods of earth flying high overhead from my leader’s Spitfire. Bader broke a pair of artificial legs in the accident, in fact, and had to send away for a new pair.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note153",
      "id": "footnote153",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("69")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("AC1 Fred Roberts:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A section of A Flight was taking off, led by Flying Officer Bader. We were watching, but what was happening? Bader didn’t seem to be rising to any height. One of the Flight Mechanics with us shouted ‘The silly bugger’s in coarse pitch!’ "), _c('a', {
    attrs: {
      "id": "page75"
    }
  }, [_vm._v("The Spitfire hit the stone wall bounding the airfield and made a belly landing on the other side. Today it would be classified as pilot error, but in those days, it was a bloody great gaffe. In the pile-up Bader bent his metal legs badly. It could have been worse had he not had those legs!")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note154",
      "id": "footnote154",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("70")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Flight Sergeant George Unwin:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sometime after Bader’s accident we were at Horsham and Bader persisted in filing his new pair of tin legs, to get them in perfect working order, and I remonstrated with him for scratching and scraping whilst I was trying to sleep. The Disney film "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Snow White and the Seven Dwarfs")]), _vm._v(" was very popular at that time and Bader replied ‘Oh shut up, Grumpy!’ From then on, that was my nickname!"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note155",
      "id": "footnote155",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("71")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Spitfire concerned in Bader’s latest faux pas, K9858, was written off. It was an extremely stupid mistake on Bader’s part, earning a rebuke from Squadron Leader Stephenson and a ‘snarled response’ from the entirely blameworthy pilot"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note156",
      "id": "footnote156",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("72")])]), _vm._v(" who was becoming increasingly unhappy on 19 Squadron. Bader told his CO, ‘Look, I don’t feel happy flying behind these younger chaps. I’m more experienced, older, although I’ve not got so many hours on Spitfires.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note157",
      "id": "footnote157",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("73")])]), _vm._v(" The fact was Douglas was unhappy as part of a team, only happy if leading it. Fortunately for all involved the ‘associations of Cranwell’ once more came to his rescue. The CO of another Duxford Spitfire squadron, 222, Squadron Leader H.W. ‘Tubby’ Mermagen, was another Cranwellian, and Bader knew that 222 needed a replacement flight commander. Bader asked Mermagen to approach the AOC, which, with Woodhall’s support, he did, and so it was that, on 16 April 1940, the newly promoted Flight Lieutenant Douglas Bader took command of 222 Squadron’s A Flight. Frank Brinsden summed up the feeling on 19 at Bader’s departure: ‘Although we all admired Douglas, I wasn’t the only pilot not sorry to see him go.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note158",
      "id": "footnote158",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Douglas Bader, of course, went on to much better things, and will return to centre stage in due course.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 21 February the AOC inspected 19 Squadron which performed a ‘quick re-arm’… ‘in 16 minutes 25 seconds’ for the Air Vice-Marshal’s benefit."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note159",
      "id": "footnote159",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("75")])]), _vm._v(" Owing to the terrible weather, however, there was very little flying overall, although Squadron Leader Stephenson led the Squadron on full "), _c('a', {
    attrs: {
      "id": "page76"
    }
  }, [_vm._v("formation practice, and both A and B Flights undertook affiliation exercises with Wellingtons from Bassingbourne over two days towards the month’s end.")])]), _c('a', {
    attrs: {
      "id": "page76"
    }
  }), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page76"
    }
  }, [_vm._v("Still the Squadron trained at night, even though, of course, the Spitfire had not been designed with night-flying or interceptions in mind. Such training and practice flights took place on 29 February 1940. Pilot Officer ‘Horrie’ Trenchard was flying that evening and night, having joined 19 Squadron four months previously. With 776 flying hours recorded in his log book, Trenchard was not an inexperienced pilot; he also had 2.50 flying hours on Spitfires at night. Not having flown at night, however, since 21 December 1939, his flight commander, Flight Lieutenant Wilf Clouston of B Flight, ensured that, before doing so again, Trenchard first safely completed three ‘circuits and bumps’ at dusk. Duly satisfied, Clouston, who was officer in charge of night flying, authorised a longer flight at 2030 hours. At that time, Trenchard took off, in Spitfire K9809, on what was ‘a moonless night with no horizon, clouds 8/10th at 1,500 feet, visibility four to eight miles’. Clouston watched Trenchard take off and climb to 400 feet. All being well, the flight commander turned his attention to another Spitfire in the Duxford circuit.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note160",
      "id": "footnote160",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("76")])]), _vm._v(" Then, catastrophe struck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three officers and an airman at Duxford later gave evidence that")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("they saw an aircraft flying straight and level from the direction of the aerodrome and at a height between 1,000 and 2,000 feet. It turned suddenly to the left and went into a straight dive which continued until the aircraft had disappeared; all four witnesses then heard a crash. Private Mortimer, 6th Suffolk Regiment, who was on guard duty in the vicinity of the aerodrome made a similar statement."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note161",
      "id": "footnote161",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("77")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pilot Officer Trenchard crashed at Whittlesford, a few miles from the aerodrome. Given that there was ‘no horizon’, the most likely explanation for the cause of this sadly fatal crash was that having taken off, made his left-turn and accelerated out of the circuit, the pilot became disorientated, so, instead of continuing to fly straight and level, as he no doubt thought he was, the Spitfire was actually diving towards the ground. Sadly, such accidents were not uncommon, and a surprising number of aircrew lost their lives in similar circumstances during the war.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p77-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The New Zealander Pilot Officer Horace Trenchard, killed in a night-flying accident (via Claire Bibby).")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p77-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A long way from home: ‘Horrie’ Trenchard’s grave at Whittlesford in 2018.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page77"
    }
  }, [_vm._v("Fred Roberts:")])]), _c('a', {
    attrs: {
      "id": "page77"
    }
  }), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "page77"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page77"
    }
  }, [_vm._v("I was detailed to go with others to Whittlesford, where Spitfire K9809 had dived into the ground the previous night whilst practising night take-offs and landings. The pilot was killed. I was horrified when I got there. The plane was in small pieces, the engine everywhere; one belt of ammo was wrapped around an oleo leg, the wheel from which was 400 yards away. I had the propeller tip from this aircraft made into a picture frame. The second tip was taken by Charlie Stanley, the third was too damaged to be of any use. We salvaged the propeller tips from the Duxford aircraft graveyard a few days after the crash.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note162",
      "id": "footnote162",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("78")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Horace Arthur Trenchard had been born on 5 March 1912, the only son child of Horace Arthur and Mary Celia Trenchard of Lower Hutt, Wellington, "), _c('a', {
    attrs: {
      "id": "page78"
    }
  }, [_vm._v("New Zealand. Sadly, Horace’s father died, aged thirty-five, before he was born, so the new-born was named in his late father’s memory. Later, young ‘Horrie’ moved with his mother to Glenside, Johnsonville, where he attended the local primary school. Between 1926 and 1930, the young Trenchard was a boarder at Waitaki Boys’ School, Oamaru. There he became a battery sergeant in the Cadet Corps and took up boxing and tennis. For three years ‘Horrie’ was captain of the College 1st rugby XV. In 1930 he returned to Glenside, becoming captain of the Johnsonville Senior XV rugby team and personally represented Wellington in the Senior Provisional side. ‘Horrie’ was also ‘airminded’, learning to fly privately at the Wellington and Wairarapa Aero Clubs. Fulltime education complete, he became an assistant clerk in the wool department of the Wellington Meat Export Company, preparing meat samples. Six years later he moved on to the Wellington Harbour Board, becoming a clerk working on wool exports. On 12 July 1937, however, the twenty-five-year-old left New Zealand on the SS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rotorua")]), _vm._v(", bound for England to take up an SSC in the RAF. Glenville resident Gwen Silvester later recalled that the local community staged a big event for the popular ‘Horrie’, who was apparently a particular hit with the ladies. Indeed, another Glenside resident, the late Murray Henderson, described ‘Horrie’ as his ‘hero’, adding that Trenchard was ‘held in high regard’ by many fellow pupils because of his popularity and sporting prowess.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note163",
      "id": "footnote163",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("79")])]), _vm._v(" On 24 August 1937 Pilot Officer Trenchard passed through the RAF Depot Uxbridge before successfully completing flying training at Sywell’s civilian flying school and 9 FTS, Hullavington. Thereafter, on 20 October 1939, the ‘Kiwi’ was posted to 19 Squadron at Duxford. By the time of his death, the twenty-eight-year old fighter pilot had logged a number of hours on Spitfires. He was buried, a long way from home, at St Mary and St Andrew churchyard, Whittlesford.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p78.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("19 Squadron armourer Fred Roberts later found the wreckage of Pilot Officer Trenchard’s Spitfire on the dump at Duxford – so salvaged a propeller blade tip and had it made into a photo frame.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page79"
    }
  }, [_vm._v("Back in New Zealand, Mrs Trenchard had moved to Horotrata, West of Christchurch on South Island. There she received news of her only, beloved, son’s death, and a telegram expressing sympathy from New Zealand’s Minister for Defence, The Hon. F. Jones. Strangely, the circumstances of this sad loss were not communicated to the pilot’s many friends on North Island, who could only speculate as to ‘Horrie’s’ fate. They would not know, in fact, until a local historian, Claire Bibby, researched the story, leading to publication of a well-received article in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Glenside Community Newsletter")]), _vm._v(" as recently as 2006. Family friend Gwen Silvester recalled that, unsurprisingly, Mrs Trenchard took her son’s death ‘very hard’. Today, Pilot Officer Trenchard is remembered on the Johnsonville Roll of Honour, the Tawa RSA Roll of Honour, and that of Waitaki Boys’ High School.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note164",
      "id": "footnote164",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("80")])]), _vm._v(" In fact, the grief-stricken single mother donated £50 (about $4,760 today) to the latter school, which still annually awards the Trenchard Memorial Cup to outstanding young cricketers."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note165",
      "id": "footnote165",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Returning to our main narrative, on 11 March 1940 John Milne had arrived at Duxford as a ‘Flight Rigger LAC’, fresh from the RAF engineering apprentice school at Halton, and provides us a glimpse of an ‘Erk’s’ daily life:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I left school in July 1939 and joined the RAF a month later. Because my parents lived in Cambridge, Duxford was a lucky posting for me and there could not have been a better introduction to the active RAF than 19 Squadron. I was allocated to A Flight, commanded by Flight Lieutenant Brian Lane, for whom no praise is too high – wonderful man, and only twenty-three at the time – of course, we were all so young!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The war seemed remote at first, and we routinely carried out the daily inspections and periodic inspections of the aircraft and performed all the incidental duties involved in servicing the aircraft, attending their take-offs and landings. An exhilarating duty was lying across the tailplane, breathless, while the pilot ran the engine at high revs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Spitfire airframe and its installations and equipment, so far as they came under the care of a flight rigger, were not difficult to repair and maintain. The Merlin engine, with its accessories, was, I think, a bit more temperamental, particularly as regards oil and coolant leaks and loss of revs. A crew of rigger and mechanic looked after each aircraft, or sometimes two. "), _c('a', {
    attrs: {
      "id": "page80"
    }
  }, [_vm._v("Various specialist tradesmen – electricians, wireless mechanics, instrument repairers, and armourers – would appear, fiddle with their allotted bits and pieces then disappear. Wireless testing on the ground would go thus:")])]), _c('a', {
    attrs: {
      "id": "page80"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Hello Dory, hello Dory, five-three calling and testing, are you receiving me, are you receiving me, over?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Hello five-three, hello five-three, am receiving you loud and clear strength nine, over and out.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Starting the engine on an early Spitfire involved using a ‘Trolley-Acc’, a two-wheeled enclosed low hand-cart containing accumulators. One starter trolley was shared between several aircraft, so the crews became adept at high-speed trolley pulling from one Spitfire to the next … . The ‘Trolley-Acc’ had a thick cable which plugged in through a flap in the engine cowling. Once the engine had started, one of the crew pulled the cable out and took it away, being careful not to step back into the propeller! After starting the engine, the pilot would signal the ground crew to lie on the tail-plane while he ran the engine at high speed. This really took one’s breath away. After ‘chocks away’ the two crew would take the wingtips and see the aircraft away from its parking area, until waved away by the pilot. Wheel chocks were originally individual items, with a man each to pull a rope which was so wrapped around the chock as to swivel it away under the wheel and prevent it from jamming. The later system was to have both chocks connected by a steel angle iron, which enabled a pair of ground crew to execute a co-ordinated and speeded-up chock removal action.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An arduous job was pumping up the oleo legs – the undercarriage. It was not the pumping that was hard but dragging the heavy equipment around the airfield. It consisted of a long vertical pump arm, a pump and a pressure-gauge to check the air pressure in the leg, all mounted on a large and heavy plank of wood, just like a railway sleeper.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page80"
    }
  }, [_vm._v("One needed a strong back to service the Spitfire. The daily inspection included lifting the tail with one’s back under the tailplane, to check the tail-wheel’s functioning, and also similarly lifting each mainplane in turn, beside the undercarriage attachment, to check the pintle bolt (holding the wing spar) ")]), _c('a', {
    attrs: {
      "id": "page81"
    }
  }, [_vm._v("by its creaking or silence when dropped again. Some jobs were more complicated: one I remember was changing a stern-frame (whole tail) in the hangar at Duxford.")])]), _c('a', {
    attrs: {
      "id": "page81"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page81"
    }
  }, [_vm._v("19 Squadron operated for a time from Horsham St Faith on the outskirts of Norwich, which was under construction as a permanent RAF station. There were no hangars, workshops or living accommodation available, so the crews stayed for short tours in a hutted camp at Catton, Norwich, whence we travelled to and from Horsham by lorry. Whilst there I saw my first Cierva Autogyro. Girls used to stand in the road outside the airfield and watch us, but we mostly ignored them, preferring to spend time and money in the pub and cinema.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note166",
      "id": "footnote166",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("82")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pilot Officer Peter Howard-Williams, who described himself simply as ‘only a very junior pilot making up the numbers and being shot at,’"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note167",
      "id": "footnote167",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("83")])]), _vm._v(" had joined 19 Squadron direct from Cranwell on 17 March 1940.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In April 1940 life continued much the same for 19 Squadron, operating out of Horsham and protecting convoys. The personal diary of Flying Officer Matheson (who had been promoted in July 1939) provides a revealing insight into this period:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('u', [_vm._v("4 April")]), _vm._v(": Leave ends at midday. Do not feel well so do not fly. Play squash with Lane in the evening. B Flight on night duty and Searchlight Co-operation.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('u', [_vm._v("5 April")]), _vm._v(": Available fifteen minutes in the Mess at 4.50 am. Not brought to Readiness. No flying in the morning. At 2 o’clock I, with three other pilots, Pilot Officers Brinsden and Lyne and Sergeant Potter, leave for Ternhill in a Blenheim of 222 Squadron to collect four new Spitfires. Weather good but deteriorating near Ternhill. Take off from Ternhill in formation at 4.15 pm. Brinsden slips neatly into the box on leaving the ground. Beat up Ternhill. Steered good course for Duxford. Weather very rough. Beat up Duxford and then S’s house, thinking that it was Saturday [author’s note: referring to a girlfriend, Sadie Kitchen].")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lane goes on 48 hrs leave. I am in charge of A Flight. Released at 8 o’clock.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page82"
    }
  }, [_c('u', [_vm._v("8 April")]), _vm._v(": Wakened up at 4 am for Searchlight Co-operation. Consult with Lane and we decide not to do it. Visibility 4,000 yards. Released from dawn to midday.")])]), _c('a', {
    attrs: {
      "id": "page82"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('u', [_vm._v("11 April")]), _vm._v(": Wing Commander Woodhall tells me that it is possible that I may get a Flight in 222 Squadron. I do so hope this is so.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('u', [_vm._v("12 April")]), _vm._v(": Have Ariel at aerodrome to get away quickly, so that I can get to Cambridge in time to take S. to see "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("French without Tears")]), _vm._v(". Lane comes to the film on the back of my motorcycle and we nearly run into 222’s Spitfires in our hurry.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('u', [_vm._v("13 April")]), _vm._v(": Readiness at 5.40 am. Take off for Horsham with B Flight. Have sleep at Horsham then breakfast. Searchlight Co-operation for an hour in the morning. I fly in cloud for a considerable period to practise Instrument Flying. Have lunch on return. Sleep afterwards. Suddenly awakened and ordered to take off in short time. Patrol Cromer 10,000 feet. Sight convoy off coast which looks like it is being bombed. Send Yellow 3, P/O Lyne, to investigate. Meanwhile ordered to patrol Cromer at 15,000 feet. One unidentified aircraft is seen. Cloud base approximately 12,000 feet. Order No. 2, Sgt Jennings, to patrol beneath cloud base, I patrol above. No sign of aircraft. Ordered return to forward base. By this time tea is ready. At about 7.30, ordered return to Duxford having told them weather is deteriorating. Fly sections line abreast. Aircraft line astern peel off over Duxford. Inform my section and lead Lane out of the aerodrome doing a tarmac landing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unfortunately, Wing Commander Woodhall, Station CO, is on aerodrome. Have strip torn off, but he is trying not to laugh while doing so.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page82"
    }
  }, [_c('u', [_vm._v("14 April")]), _vm._v(": Readiness 5.40 am, Duxford. Sleep until 10 am. Lane relieved us at 11 o’clock. Return to Mess for a bath etc. Readiness for my Section throughout the day, which Lane and I share out. Tactical Exercise for 4.30 but is cancelled. B Flight brought back from Horsham then immediately sent back again. Clouston furious. Released at 9.10 pm.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note168",
      "id": "footnote168",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("84")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 15 April another pilot was posted to 19 Squadron who would become significant in the dramatic months ahead: Pilot Officer Walter John ‘Jack’ Lawson, who arrived from 46 Squadron at Digby.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page83"
    }
  }, [_vm._v("Jack Lawson, known to all on 19 Squadron as ‘Farmer’, was born in Taunton on 30 January 1913. His father, Thomas Castle Lawson, was a military man, a captain in the Royal Horse Artillery, but sadly his first wife died young, aged fifty-two, in 1911. Thomas, the father of three boys and three girls, re-married six months later, to Julia Poulton Fuller, known as ‘Peggy’. A further tragedy befell Thomas, however, when just twelve days after his second wedding, his youngest son, also Thomas, died, aged nineteen. Only a week later, Captain Lawson retired from the army and became the Superintendent of Clothing and Assistant Secretary of the Somerset Territorial Force Association, moving his family from Aldershot to Taunton. When the First World War broke out, Captain Lawson was mobilised and became quartermaster to 22nd Brigade Royal Field Artillery, based in Brighton, to which seaside town the family then moved; a sister and brother for Jack followed, and after Major Lawson, as he then was, finally retired the family moved to St Leonard’s-on-Sea in East Sussex. Jack’s father, however, died in 1925, leaving his second wife their three children and one stepchild to raise. Jack was educated at Hastings Grammar School, but with reduced circumstances following the ’Mad Major’s’ death, as his father was known, Jack was unable to continue his education beyond achieving his School Certificate. Consequently, on 17 January 1929, just four days after his sixteenth birthday, Jack enlisted in the RAF as a boy entrant for twelve years and went to train as an aircraft apprentice at No. 1 School of Technical Training, Halton. A year later Jack specialised in aircraft engine maintenance, leaving Halton in January 1932 as an LAC (Fitter Aero Engines) upon posting to 25 Squadron at Hawkinge.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note169",
      "id": "footnote169",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("85")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p83.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jack ‘Farmer’ Lawson pictured as a sergeant pilot before the war on 46 Squadron at Digby (Trevor Lawson).")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No. 25 was a fighter squadron, flying Snipe, Grebe, Siskin and Hart biplanes during the time Jack spent with the unit. In December 1935, however, Jack was another airman to benefit from Trenchard’s expansion plans when his application to re-muster as a pilot was accepted. At No. 1 "), _c('a', {
    attrs: {
      "id": "page84"
    }
  }, [_vm._v("Training Wing, Henlow, Jack started on the pathway to becoming a fighter pilot, and successfully completed his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ab initio")]), _vm._v(" flying training at Yatesbury with a score of 84 per cent. His conversion to modern service types completed with 10 FTS at Ternhill. On Christmas Day 1936 Jack was posted as a ‘Pilot/Fitter Aero Engines’ to 46 Squadron, based at Kenley. There he flew Gloster Gauntlets, on which type he was officially considered proficient by April 1937, when he was also promoted to sergeant. Coincidentally, his younger brother, Norman, had followed Jack to Halton and at this time was a fitter serving with 17 Squadron, another proud fighter squadron based at Kenley.")])]), _c('a', {
    attrs: {
      "id": "page84"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page84"
    }
  }, [_vm._v("In November 1937 46 Squadron left Kenley and 11 Group for the wilds of Lincolnshire, setting up home at Digby, a sector station near the east coast and in 12 Group. By August 1938 Sergeant Lawson was experienced on the Gauntlet, Hart and Audax, and assessed as ‘above average’ as both a pilot and air gunner.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note170",
      "id": "footnote170",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("86")])]), _vm._v(" In February 1939, however, 46 Squadron converted to the Hawker Hurricane, Jack’s first flight on the new type being in L1806 on 9 February, landing with a punctured starboard tyre. Thereafter followed the typical training and familiarisation flights as 46 also gained experience on this new monoplane fighter. Having signed on for a further twenty-four years’ service on 13 July 1939, "), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note171",
      "id": "footnote171",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("87")])]), _vm._v(" on 1 August his ability as a fighter pilot was rated as ‘Exceptional’."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note172",
      "id": "footnote172",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("At the end of June 1939 the Women’s Auxiliary Air Force (WAAF) was formed, enabling females to serve and, as time went on, undertake such duties as parachute packing, manning barrage balloons, catering, telephonic and telegraphic duties, photographic reconnaissance analysis, intelligence, meteorology, aircraft maintenance and as ‘plotters’ in operations rooms (more of which later), tracking the movements of friendly and enemy aircraft. So it was that WAAFs began arriving at RAF stations, including Digby.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p84.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Acting Section Officer Margaret ‘Peggy’ Balfour of Ops ‘B’, Digby, in 1940.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page85"
    }
  }, [_vm._v("Amongst the WAAF contingent there on 8 December 1939 was new arrival ACW2 Margaret ‘Peggy’ Balfour:")])]), _c('a', {
    attrs: {
      "id": "page85"
    }
  }), _c('div', {
    staticClass: "block-quote"
  }, [_c('a', {
    attrs: {
      "id": "page85"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page85"
    }
  }, [_vm._v("A week or two after we had arrived at Digby, I remember going to a camp dance held in the Sergeants’ Mess. I had never before been to a dance unescorted, and without really knowing who would be there or what it would be like. However, I was standing in the hall doorway, in the shadows, taking stock of my surroundings before venturing in. It all looked great fun. The music was playing merrily and everyone seemed to be dancing happily. I remained where I was. Then someone came over and asked me to dance with him. What a joy – he was tall and danced beautifully. I loved dancing. We danced and chatted, and then he called across to one of his friends, ‘Tubby!\nGuess what? I’m dancing with a WAAF who is asking about centrifugal force!’ I had asked him! I wanted to know. I had been reading an article, which I did not understand, about it in my "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Times")]), _vm._v(" that morning in Ops. I learnt that my dancing partner’s name was Jack Lawson and that he was a sergeant pilot in 46 Squadron flying Hurricanes, like many of the other pilots present. Before 46 Squadron left Digby, I got to know Jack ‘Farmer’ Lawson well. He never fussed me, and danced beautifully, completely to my liking. And above all he was great fun and made me laugh.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note173",
      "id": "footnote173",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("89")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Romance soon blossomed:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("When Jack was free, he sent notes to the Guard Room asking when he could meet me. It was all fun. Jack had a car so we were able to leave the camp. We used to visit local pubs or buy fish and chips and eat them out of newspaper. The weather always seemed fine and sunny. We laughed a lot, and were always talking, we talked about everything, putting the world to rights, and we argued as we certainly did not agree all the time. I remember that he always teased me about my ideas and think he thought me a little mad. But we enjoyed our jaunts into the countryside and had a lot of fun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By this time we WAAFs had met lots of people on the camp and were finding our way around. We started playing tennis, "), _c('a', {
    attrs: {
      "id": "page86"
    }
  }, [_vm._v("although Jack and I never managed one game together; duty always intervened. Once we did manage to get our racquets out of their presses and were actually out on the court when the siren sounded and Jack had to fly. That is the only time I ever saw him angry, but he was then. We had tried so hard to get a game together but it was not to be. We did enjoy life. There were dances attended by the whole camp, and I usually danced the last dance with Jack.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note174",
      "id": "footnote174",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("90")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 31 March 1940 Jack Lawson was commissioned as a pilot officer. On 5 April he made his last flight in a Hurricane and left Digby on posting to 19 Squadron with an ‘Exceptional’ assessment from his CO, arriving there and joining A Flight on 15 April.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The flying continued during spring 1940 largely unchanged, 19 Squadron still operating out of Horsham practising gunnery at Sutton Bridge, and undertaking RDF exercises, affiliation with Blenheims and uneventful patrols. Flying Officer Matheson’s diary:")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/p86.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Geoffrey Matheson pictured whilst a flight lieutenant commanding a flight on 222 Squadron (Howard and Lorraine Eastcott).")])]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('u', [_vm._v("21 April")]), _vm._v(": In the afternoon I fly to Duxford and send Magister with fitter to put the Magister stuck, right. Both Magisters return to Duxford about 7 pm. Send P/O Baker on to Horsham immediately with a Magister. P/O Howard-Williams stays behind to take back the CO’s Spitfire. I leave Duxford at 8 o’clock with H-W in formation with me; I misjudge the amount of light and we arrive at Horsham in the dark. "), _c('a', {
    attrs: {
      "id": "page87"
    }
  }, [_vm._v("I land alright but H-W lands in the wrong direction and goes straight through the obstructions. He damages the CO’s aircraft. Clouston and the CO furious. Can’t really blame them. I am put under arrest by the CO. As the CO did not specify, it should mean ‘close arrest’ but as he has not placed another officer to guard I take it to mean ‘open arrest’. I feel pretty bad about the whole thing because I take particular pride in being careful when I lead people about the sky. It is not H-W’s fault because he is very inexperienced. Lucky he didn’t kill himself.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note175",
      "id": "footnote175",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("91")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Interestingly, there is no record of this accident in 19 Squadron ORB, a not altogether uncommon scenario and evidence of how incomplete such records often are. Although this accident, involving Spitfire K9820, was not Pilot Officer Howard-Williams’s fault, he was a somewhat accident-prone pilot who would earn the nickname ‘Crasher’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The diary continues:")]), _vm._v(" "), _c('div', {
    staticClass: "block-quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('u', [_vm._v("25 April")]), _vm._v(": Training flying in the morning. Make a weather test at about 1115 am. It is very thick below 1,500 feet. Above 2,000 it is very clear but towards the sea there is 10/10ths. There is cloud at about 1,500 feet, coupled with fog. No good for operations over the sea. It clears enough to do attacks. I lead the Target Section and F/Sgt Unwin the Attacking Section. Unwin’s wireless unserviceable, which rather spoils it. Standing-by in the afternoon …. Jennings makes a boob with the flare path. CO orders him to put it out four evenings running. He goes on leave tomorrow but will do it upon return. The lads go out for a special evening this evening, wish I could go with them but am Confined Camp (CC) until Sunday. Still, I am up at 4.30 am tomorrow morning so I suppose it is better to stay in and go to bed early anyhow. Hear that Pilot Officer Kennedy has been killed at Duxford. Apparently, he spun in from 500 feet whilst doing low-flying attacks. [This fatal accident, however, did not concern a 19 Squadron pilot but one of 66, which on the day in question was undertaking an affiliation exercise with the Blenheims of 15 Squadron from Alconbury; Pilot Officer R.G. Kennedy’s Spitfire, N3224, ‘spun down from 400 feet and crashed at Kimbolton.’]"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note176",
      "id": "footnote176",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("92")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('u', [_vm._v("26 April")]), _vm._v(": "), _c('a', {
    attrs: {
      "id": "page88"
    }
  }, [_vm._v("Lane returns from leave, we have a laugh over my CC and a rest. Nothing much happens today.")])]), _c('a', {
    attrs: {
      "id": "page88"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page88"
    }
  }, [_c('u', [_vm._v("27 April")]), _vm._v(": Squadron Leader Stephenson tells me that I can now leave camp. I arrange to go out in the evening. In the afternoon just as Lane, Unwin and I become Red Section, as in the early days of the war, we are told to leave the ground. We are sent to Yarmouth. There is a German about but we cannot see him. He apparently sees us and makes off for Germany. We return to base. We are off again at 15,000 feet over the coast. We are then brought to Duxford at the same height. There are a lot of clouds and we pass closely round a very large thunderstorm. We see nothing. Return to Horsham. Go out to ‘Samson and Delilah’ [author’s note: actually the ‘Sampson and Hercules’ nightclub in Norwich] in the evening.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note177",
      "id": "footnote177",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("93")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The previous day, Flying Officer ‘Ace’ Pace, who had long served with 19 Squadron, was posted away to 85, to fly Hurricanes ‘somewhere in France’."), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note178",
      "id": "footnote178",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("94")])]), _vm._v(" (Pace would be shot down and terribly burned on 15 May 1940; after plastic surgery, he returned to operational flying but was reported missing as a squadron leader on 3 December 1941.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Overall, Brian Lane’s ‘queer war’ appeared to be continuing indefinitely, or so it seemed. Indeed, for the first three months of 1940 little had happened. The Soviets finally overwhelmed the Finns, and U-boats continued attacking Britain’s North Atlantic shipping, but elsewhere the ‘Phoney War’ persisted. With the exception of the Czechs and Poles, few people had thus far suffered unduly from the conflict. The truth was that neither the British nor French favoured early military action against Germany. In an unfortunately pronounced confirmation of his astonishing naivety, Chamberlain clung desperately to the forlorn hope that Hitler could still be persuaded to abandon his European territorial ambitions, thereby avoiding a hot war. Intelligence reports suggested that Germany’s intensive re-armament programme had actually weakened the internal economy and created shortages of essential raw materials. Britannia, of course, had long ruled the waves, so Chamberlain believed that a naval blockade could strangle Germany and engineer Hitler’s downfall. The French agreed. Whilst the strategy was pursued, Britain and France continued re-arming and preparing defences. In October 1939, in fact, Germany offered to discuss peace, various world leaders then encouraging Britain to continue exploring options for a compromise peace. No deal, however, could be brokered, so far as Britain and France were concerned, "), _c('a', {
    attrs: {
      "id": "page89"
    }
  }, [_vm._v("without the restoration of Czechoslovakia and Poland, and the precondition that the Nazi government was eliminated. Naturally the Germans refused to give up any territory, and there was no question of Hitler relinquishing power. So, Brian’s ‘queer war’ went on and on.")])]), _c('a', {
    attrs: {
      "id": "page89"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page89"
    }
  }, [_vm._v("During the winter of 1940, however, both sides recognised the strategic importance of Scandinavia. Swedish iron ore was essential to German industry, and the occupation of Denmark and Norway would provide Germany ports from which the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kriegsmarine")]), _vm._v(" could reach the Atlantic and further threaten Britain’s essential maritime supply lines. Conversely, if Britain and France could obstruct the supply of iron ore to Germany, Hitler’s economy and industry might be irrevocably damaged. The improved weather of spring 1940, therefore, saw both camps focused on Scandinavia. German troops landed on 9 April 1940. Britain sent a taskforce steaming to Narvik but, just two weeks later, British land forces were evacuated. This unsuccessful British campaign, in fact, highlighted the problems ahead owing to the lack of a long-range fighter. Flying from aircraft carriers, air cover for the British taskforce had been provided by a handful of obsolete Gloster Gladiator biplanes and just one squadron of modern Hurricanes. Losses indicated the disparity in performance between the British and German aircraft in actual combat, and Air Chief Marshal Dowding, C-in-C of Fighter Command, was also vexed by the Royal Navy’s (RN) inability to prevent what had been a German seaborne invasion. Dowding’s concern was whether the RN would be any more successful in preventing an amphibious invasion of Britain?")]), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note179",
      "id": "footnote179",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By now a dark and sinister shadow was enveloping Europe, the barbarity of which was already evident in Poland. There, since Germany’s victory, ‘torture and killing had continued without abatement.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes#note180",
      "id": "footnote180",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("96")])]), _vm._v(" On 14 April 1940 alone, 220 Poles, including women and children, were shot near Serokomla. On 1 May Lodz’s 160,000 Jews were forbidden to leave what had become an overcrowded area, German police ordered to shoot any Jew approaching the barbed-wire fence enclosing the ghetto. In Poland, then, an unspeakable horror had already begun, the ‘cumulative radicalisation’ of which would ultimately lead to the virtual destruction of European Jewry and mass murder of countless other ‘undesirables’. A ‘queer war’ to some it may well have been, but to those in the occupied lands the grim realisation of Hitler’s racial policies was already beyond terrifying, providing an indication of what lay in store for a defeated Britain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whilst the West continued awaiting the hammer-blow, the world held its breath.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0495abe9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_chapter_003.vue
// module id = 81
// module chunks = 0